import styled from "styled-components";
import { headerSize, panelSpacing } from "../../../common/styles";
import colors from "../../../config/colors";

export const HeaderContainer = styled.div`
  padding: 9px 24px;
  ${"" /* min-height: 63px; */}
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.primary};
  @media (max-width: 1600px) {
    padding: 2px 10px;
  }
`;
export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
export const LogoContainer = styled.div`
  z-index: 5;
  cursor: pointer;
`;
export const HeaderOption = styled.div`
  font-size: ${(15 / 50) * headerSize}px;
  padding: 0px 25px;
  height: ${headerSize}px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  color: ${(props) => (props.active ? colors.primary : colors.background)};
  background-color: ${(props) =>
    props.active ? colors.background : colors.primary};
  box-shadow: ${(props) =>
    props.active ? `0px 5px 5px 1px #00000022` : "none"};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  :active {
    transform: scale(0.95);
  }
`;
export const IconOption = styled(HeaderOption)`
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${headerSize}px;
  width: ${headerSize}px;
  box-sizing: border-box;
`;
export const Premium = styled(HeaderOption)`
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${headerSize}px;
  width: ${headerSize}px;
  box-sizing: border-box;
`;
export const UserOption = styled(HeaderOption)`
  padding: ${(10 / 50) * headerSize}px;
  // padding: 0;
  ${(props) =>
    !props.noEffect
      ? `  :active {
            transform: scale(1) !important;
          }`
      : null};
`;
export const UserImage = styled.img`
  height: ${(30 / 40) * headerSize}px;
  width: ${(30 / 40) * headerSize}px;
  object-fit: cover;
  border-radius: 50%;
  border: solid 1px ${colors.primary};
`;

export const ProfileDropdown = styled.div`
  position: absolute;
  top: 48px;
  right: ${(props) => (props.visible ? 0 : -200)}px;
  // width: fit-content;
  background-color: ${colors.text}88;
  // backdrop-filter: blur(5px);
  padding: 0px;
  border-top: 15px solid #44449b;
  box-sizing: border-box;
  transition: all 0.3s;
  width: 200px;
  border-radius: 0px 0px 0px ${panelSpacing}px;
  z-index: 150;
  transform: scale(1) !important;
  &:active {
    transform: scale(1) !important;
  }
  @media (max-width: 1600px) {
    top: 42px;
    border-top: 8px solid #44449b;
  }
`;
export const ProfileOption = styled.div`
  background-color: ${(props) =>
    props.active ? colors.primary : colors.background};
  color: ${(props) => (props.active ? colors.background : colors.primary)};
  padding: ${panelSpacing / 2}px;
  font-size: ${(15 / 50) * headerSize}px;
  font-weight: normal;
  margin: ${panelSpacing / 4}px;
  cursor: pointer;
  border-radius: ${panelSpacing}px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  transition: all 0.3s;
  :hover {
    font-weight: bold;
  }
`;
export const ProfileBorder = styled.hr`
  margin: 0px;
`;

export const LogoImage = styled.img`
  vertical-align: bottom;
  width: 100%;
  height: 100%;
`;
